/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlPrePurchaseProducts
 */
export interface ControlPrePurchaseProducts {
    /**
     * 
     * @type {string}
     * @memberof ControlPrePurchaseProducts
     */
    product_id: string;
    /**
     * 
     * @type {number}
     * @memberof ControlPrePurchaseProducts
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPrePurchaseProducts
     */
    product_pre_tax_total_price: number;
}

/**
 * Check if a given object implements the ControlPrePurchaseProducts interface.
 */
export function instanceOfControlPrePurchaseProducts(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "product_id" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "product_pre_tax_total_price" in value;

    return isInstance;
}

export function ControlPrePurchaseProductsFromJSON(json: any): ControlPrePurchaseProducts {
    return ControlPrePurchaseProductsFromJSONTyped(json, false);
}

export function ControlPrePurchaseProductsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPrePurchaseProducts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_id': json['product_id'],
        'quantity': json['quantity'],
        'product_pre_tax_total_price': json['product_pre_tax_total_price'],
    };
}

export function ControlPrePurchaseProductsToJSON(value?: ControlPrePurchaseProducts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_id': value.product_id,
        'quantity': value.quantity,
        'product_pre_tax_total_price': value.product_pre_tax_total_price,
    };
}

